import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import CybersecurityNewsSection from './components/CybersecurityNewsSection';
import NewsSection from './components/NewsSection';
import Blog from './components/Blog';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Usa Routes en lugar de Switch

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            {/* Rutas para las diferentes páginas */}
            <Route path="/" element={<Home />} />
            <Route path="/CybersecurityNewsSection" element={<CybersecurityNewsSection />} />
            <Route path="/NewsSection" element={<NewsSection />} />
            <Route path="/NewsSection" element={<NewsSection />} />
            <Route path="/Blog" element={<Blog />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
